import cookie from 'react-cookies';

import axios from 'axios';

import mock from '../mock/api-payload.json';

export const apiBaseUrl =
  process.env.REACT_APP_API_BASEURL || 'https://amazon-services.lendistry-dev.net';

const loanId = process.env.REACT_APP_LOAN_ID || '1';

const getLoanProductId = () => {
  return localStorage.getItem('loanProductId') || loanId;
};
export const createApplication = async () => {
  const token = cookie.load('lendistry_tokens_access');

  return axios.post(
    `${apiBaseUrl}/sbl-app/marketableloans/${getLoanProductId()}/applicationinstances`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const getApplication = async () => {
  const token = cookie.load('lendistry_tokens_access');
  const appId = cookie.load('appId');
  if (appId) {
    return axios.get(
      `${apiBaseUrl}/sbl-app/marketableloans/${getLoanProductId()}/applicationinstances/${appId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  } else {
    return new Promise((resolve, reject) => {
      reject("There isn't active appId");
    });
  }
};

export const updateApplication = async (data) => {
  const token = cookie.load('lendistry_tokens_access');
  const appId = cookie.load('appId');
  const data1 = {
    updatedApplicationFeatures: data,
  };

  if (process.env.REACT_APP_USE_MOCK === 'true') {
    return new Promise((resolve) => {
      data.forEach((d) => {
        mock.applicationFeatures.some((feature, i) => {
          if (
            feature.dataType === d.dataType ||
            feature.itemType === d.itemType ||
            feature.name === d.name
          ) {
            mock.applicationFeatures[i].value = d.value;
          }
        });
      });
      resolve({ data: mock });
    });
  }

  return axios.patch(
    `${apiBaseUrl}/sbl-app/marketableloans/${getLoanProductId()}/applicationinstances/${appId}`,
    data1,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const getAuthenticatedContractURL = (appId, anchor) => {
  const token = cookie.load('lendistry_tokens_access');
  return `${apiBaseUrl}/sbl-app/marketableloans/${getLoanProductId()}/applicationinstances/${appId}/contract?jwt_token=${token}#${anchor}`;
};

export const getContractFile = async (appId) => {
  const token = cookie.load('lendistry_tokens_access');
  return axios.get(
    `${apiBaseUrl}/sbl-app/marketableloans/${getLoanProductId()}/applicationinstances/${appId}/contract`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const getProfile = async () => {
  const token = cookie.load('lendistry_tokens_access');
  return axios.get(`${apiBaseUrl}/account/user/profile`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const validateProperty = async (propertyName) => {
  if (process.env.REACT_APP_USE_MOCK === 'true') {
    return Promise.resolve();
  }

  const token = cookie.load('lendistry_tokens_access');
  const appId = cookie.load('appId');

  return axios.get(
    propertyName
      ? `${apiBaseUrl}/sbl-app/marketableloans/${getLoanProductId()}/applicationinstances/${appId}/validate?features=${propertyName}`
      : `${apiBaseUrl}/sbl-app/marketableloans/${getLoanProductId()}/applicationinstances/${appId}/validate`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const getPlaidLinkToken = async () => {
  const token = cookie.load('lendistry_tokens_access');
  const appId = cookie.load('appId');

  return axios.get(
    `${apiBaseUrl}/sbl-app/marketableloans/${getLoanProductId()}/applicationinstances/${appId}/plaid-linkage-token`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const getAddressSuggestions = async (search) => {
  const key = process.env.REACT_APP_STREET_API_KEY || '86486161114019636';

  return axios.get(
    `https://us-autocomplete-pro.api.smartystreets.com/lookup?key=${key}&search=${search}&source=all&license=us-autocomplete-pro-cloud&match=enhanced`,
    {},
    {
      headers: {
        'Access-Control-Allow-Origin': '*',
      },
    }
  );
};

export const getAddresses = async (street_line, city, state, zipcode) => {
  const key = process.env.REACT_APP_STREET_API_KEY || '86486161114019636';
  return axios.get(
    `https://us-street.api.smartystreets.com/street-address?street=${street_line}&city=${city}&state=${state}&zipcode=${zipcode}&agent=smartystreets+(sdk:javascript@1.8.1)&key=${key}&license=us-core-enterprise-cloud&match=enhanced`,
    {},
    {
      headers: {
        'Access-Control-Allow-Origin': '*',
      },
    }
  );
};

export const fileUpload = async (file, fileType, cancelToken) => {
  const token = cookie.load('lendistry_tokens_access');
  const appId = cookie.load('appId');

  return axios.post(`${apiBaseUrl}/sbl-file/upload/application/${appId}/${fileType}`, file, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data',
    },
    cancelToken,
  });
};

export const fileOpen = async (fileID, fileType) => {
  const token = cookie.load('lendistry_tokens_access');

  return axios.get(`${apiBaseUrl}/sbl-file/download/file/${fileType}/${fileID}`, {
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/octet-stream',
    },
  });
};

export const refreshToken = async () => {
  const token = cookie.load('lendistry_tokens_access');
  const refreshToken = cookie.load('lendistry_tokens_refresh');
  return axios.post(
    `${apiBaseUrl}/account/signin/token/refresh`,
    {
      refreshToken,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const getLoanProducts = async () => {
  return axios.get(`${apiBaseUrl}/public/sbl-app/marketableloans`, {
    withCredentials: true,
  });
};

export const getApprovedAmazonLoanDetails = async () => {
  const appId = cookie.load('appId');
  const token = cookie.load('lendistry_tokens_access');

  return axios.get(
    `${apiBaseUrl}/sbl-app/marketableloans/${getLoanProductId()}/applicationinstances/${appId}/approved-rate-details`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const getApplications = async () => {
  const token = cookie.load('lendistry_tokens_access');
  return axios.get(
    `${apiBaseUrl}/sbl-app/applicationinstances?page=1&page_size=20&sort=created_date`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const getPublicApplicationDetails = async () => {
  return axios.get(`${apiBaseUrl}/public/sbl-app/marketableloans/${getLoanProductId()}`, {
    withCredentials: true,
  });
};

export const getDocuSignLink = async () => {
  const appId = cookie.load('appId');
  const token = cookie.load('lendistry_tokens_access');
  return axios.get(
    `${apiBaseUrl}/sbl-app/marketableloans/${getLoanProductId()}/applicationinstances/${appId}/contract-link`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const getContract = async (contract) => {
  const token = cookie.load('lendistry_tokens_access');
  return axios.get(`${apiBaseUrl}/sbl-file/download/file/contract/${contract}`, {
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const updateIdValidateInquiryId = async () => {
  const appId = cookie.load('appId');
  const token = cookie.load('lendistry_tokens_access');

  return axios.get(
    `${apiBaseUrl}/sbl-app/marketableloans/${getLoanProductId()}/applicationinstances/${appId}/resume-inquiry`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const getNAICSCode = async (value) => {
  const token = cookie.load('lendistry_tokens_access');

  const jsonData = JSON.stringify({
    query: {
      match_phrase_prefix: {
        descriptions: {
          query: value,
          slop: 3,
        },
      },
    },
    highlight: {
      fields: {
        descriptions: {},
      },
    },
  });
  var naicsSearchURL =
    'https://search.' +
    (process.env.REACT_APP_ENV === 'dev' ? 'lendistry-dev.net' : 'mylendistry.com') +
    '/naics/_search';
  return axios.post(naicsSearchURL, jsonData, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
};

export const validateRoutingNumber = async (routingNumber) => {
  const token = cookie.load('lendistry_tokens_access');

  const jsonData = JSON.stringify({
    query: {
      multi_match: {
        fields: ['Routing Number', 'New Routing Number'],
        query: routingNumber,
        type: 'phrase_prefix',
      },
    },
  });

  const baseUrl = 'mylendistry.com';
  var routingNumberSearchURL = 'https://search.' + baseUrl + '/aba/_search';
  return axios.post(routingNumberSearchURL, jsonData, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
};
